import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TravelExpensesComment } from '../../../lib/types/models/travel-expenses/travel-expenses-comment'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getTravelExpensesComments(input: PaginationRequest & { affectedStaffId: number }) {
  const { affectedStaffId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.affectedStaffs.getTravelExpensesComments.url, { affectedStaffId }),
        rest
      )
    )
    .get<PaginationResponse<TravelExpensesComment>>()
}
